import React from 'react';
import config from 'config/configIcon';
export default class RenderIcons extends React.PureComponent {
  render() {
    if (!(this.props.icon in config)) {
      return (this.props.icon || ' ').substr(0, 1);
    }
    return config[this.props.icon];
  }
}
